const config = {
  id: 25,
  name: '品牌日 一',
  type: 1,
  module_code: 'active_day', // bind的配置文件
  icon: 'icon-tms-red-packet',
  font_icon: '&#xe60c;',
  style_type: 1,
  link_type: 0,
  property_data: {
    type: 1,
    background_color: '#fee5e5',
    title_color: '#FE7381',
    sale_color: '#FE7381',
    subtitle_bg_color: '#ff606f',
    btn_lf_text_color: '#FEF6E3',
    btn_rt_text_color: '#DF6446',
    btn_lf_bg: ['#FC6F84', '#FC9380'],
    btn_rt_bg: ['#F3C1A7', '#FDF3E5'],
    list: [],
  }
};

export default config;


